import * as userAPI from '../api/users'
import * as types   from "../mutation-types"

// initial state
const users = {
  namespace: 'users',
  state: {
    all: [],
    recipients: [],
  },
  getters: {
    users: (state, getters) => state.all.filter(user => getters.company.initials === null || user.company ===
                                                        getters.company.initials)
                                    .sort((a, b) => b.id - a.id),
    usersWithRecipientCount: (state, getters) => getters.users.map(user => {
      return Object.assign({}, user, {
        recipients: state.recipients.filter(recipient => recipient.user_id === user.id).length
      })
    }),
    userRecipients: (state) => state.recipients
  },
  mutations: {
    [types.LOAD_ALL_USERS]: (state, data) => {
      state.all        = data.users
      state.recipients = data.recipients
    },
    [types.LOAD_USER]: (state, data) => {
      let stateUser = state.all.find(u => u.id === data.user.id)
      if (typeof stateUser !== 'undefined') {
        state.all.splice(state.all.indexOf(stateUser), 1, data.user);
      }
      else {
        state.all.push(data.user);
      }
      data.recipients.forEach(recipient => {
        let stateRecipient = state.all.find(r => r.id === recipient.id)
        if (typeof stateRecipient !== 'undefined') {
          state.recipients.splice(state.recipients.indexOf(stateRecipient), 1, recipient);
        }
        else {
          state.recipients.push(recipient);
        }
      })
    },
    [types.CREATE_USER]: (state, user) => {
      state.all.push(user)
    },
    [types.UPDATE_USER]: (state, user) => {
      let stateUser = state.all.find(u => u.id === user.id)
      state.all.splice(state.all.indexOf(stateUser), 1, user);
    },
    [types.DELETE_USER]: (state, user) => {
      let stateUser = state.all.find(u => u.id === user.id)
      state.all.splice(state.all.indexOf(stateUser), 1);
    },
    [types.SET_PRIMARY_RECIPIENT]: (state, user) => {
      let stateUser = state.all.find(u => u.id === user.id)
      state.all.splice(state.all.indexOf(stateUser), 1, user);
    },
    [types.CREATE_USER_RECIPIENT]: (state, recipient) => {
      state.recipients.push(recipient)
    },
    [types.UPDATE_USER_RECIPIENT]: (state, recipient) => {
      let stateRecipient = state.all.find(r => r.id === recipient.id)
      state.recipients.splice(state.recipients.indexOf(stateRecipient), 1, recipient);
    },
    [types.DELETE_USER_RECIPIENT]: (state, recipient) => {
      let stateRecipient = state.all.find(r => r.id === recipient.id)
      state.recipients.splice(state.recipients.indexOf(stateRecipient), 1);
    },
  },

  actions: {
    [types.LOAD_ALL_USERS]: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        userAPI.loadAllUsers(commit)
               .then(data => {
                 commit(types.LOAD_ALL_USERS, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.LOAD_USERS_PAGE]: ({ commit, dispatch, state }, options) => {
      return new Promise((resolve, reject) => {
        userAPI.loadUsersPage(commit, options)
               .then(data => {
                 commit(types.LOAD_ALL_USERS, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.SEARCH_USERS]: ({ commit, dispatch, state }, options) => {
      return new Promise((resolve, reject) => {
        userAPI.searchUsers(commit, options)
               .then(data => {
                 commit(types.LOAD_ALL_USERS, data)
                 commit(types.REFRESH_OR_ADD_ORDERS, data.orders)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.CREATE_USER]: ({ commit, dispatch, state }, userData) => {
      return new Promise((resolve, reject) => {
        userAPI.createUser(commit, userData.fields)
               .then(data => {
                 commit(types.CREATE_USER, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.UPDATE_USER]: ({ commit, dispatch, state }, userData) => {
      return new Promise((resolve, reject) => {
        userAPI.updateUser(commit, userData.fields)
               .then(data => {
                 commit(types.UPDATE_USER, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.DELETE_USER]: ({ commit, dispatch, state }, userData) => {
      return new Promise((resolve, reject) => {
        userAPI.deleteUser(commit, userData)
               .then(data => {
                 commit(types.DELETE_USER, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.LOAD_USER]: ({ commit, dispatch, state }, userID) => {
      return new Promise((resolve, reject) => {
        userAPI.loadUser(commit, { 'id': userID })
               .then(data => {
                 commit(types.REFRESH_OR_ADD_ORDERS, data.orders)
                 commit(types.LOAD_USER, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.SET_PRIMARY_RECIPIENT]: ({ commit, dispatch, state }, payload) => {
      return new Promise((resolve, reject) => {
        userAPI.setPrimaryRecipient(commit, payload)
               .then(user => {
                 commit(types.SET_PRIMARY_RECIPIENT, user)
                 resolve(user)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.CREATE_USER_RECIPIENT]: ({ commit, dispatch, state }, recipientData) => {
      return new Promise((resolve, reject) => {
        userAPI.createUserRecipient(commit, recipientData.fields)
               .then(data => {
                 commit(types.CREATE_USER_RECIPIENT, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.UPDATE_USER_RECIPIENT]: ({ commit, dispatch, state }, recipientData) => {
      return new Promise((resolve, reject) => {
        userAPI.updateUserRecipient(commit, recipientData.fields)
               .then(data => {
                 commit(types.UPDATE_USER_RECIPIENT, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.DELETE_USER_RECIPIENT]: ({ commit, dispatch, state }, recipientData) => {
      return new Promise((resolve, reject) => {
        userAPI.deleteUserRecipient(commit, recipientData)
               .then(data => {
                 commit(types.DELETE_USER_RECIPIENT, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
  },
};

export default users;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/users/index.js
// module id = 622
// module chunks = 0